export const FeatureBadge = ({ children, muted = false, ...rest }) => (
  <span
    className={`feature-badge ${muted ? 'feature-badge--muted' : ''}`}
    data-testid={`feature-badge`}
    {...rest}
  >
    {children}
  </span>
);

export const TierBadge = ({ children, ...rest }) => (
  <span className="tier-badge" data-testid="tier-badge" {...rest}>
    {children}
  </span>
);

export default FeatureBadge;
